import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import PropTypes from 'prop-types';
import React from 'react';

import InlineMessages from '../../containers/inline-messages.jsx';

import {
    createProject,
    getIsShowingWithId,
    getIsShowingWithoutId,
    manualUpdateProject
} from '../../reducers/project-state';

import {
    filterInlineAlerts
} from '../../reducers/alerts';

import styles from './save-status.css';

// Wrapper for inline messages in the nav bar, which are all related to saving.
// Show any inline messages if present, else show the "Save Now" button if the
// project has changed.
// We decided to not use an inline message for "Save Now" because it is a reflection
// of the project state, rather than an event.
const SaveStatus = ({
    alertsList,
    canCreateNew,
    canSave,
    className,
    isShowingWithoutId,
    projectChanged,
    onClickSave
}) => {
    const showSaveNow = (canSave && projectChanged) || (canCreateNew && isShowingWithoutId);

    return filterInlineAlerts(alertsList).length > 0 ? (
        <InlineMessages />
    ) : showSaveNow && (
        <button
            className={className ? `${styles.saveNow} ${className}` : styles.saveNow}
            onClick={onClickSave}
            type="button"
        >
            <FormattedMessage
                defaultMessage="Save Now"
                description="Title bar link for saving now"
                id="gui.menuBar.saveNowLink"
            />
        </button>
    );
};

SaveStatus.propTypes = {
    alertsList: PropTypes.arrayOf(PropTypes.object),
    canCreateNew: PropTypes.bool,
    canSave: PropTypes.bool,
    className: PropTypes.string,
    isShowingWithoutId: PropTypes.bool,
    onClickSave: PropTypes.func,
    projectChanged: PropTypes.bool
};

const mapStateToProps = state => ({
    alertsList: state.scratchGui.alerts.alertsList,
    isShowingWithId: getIsShowingWithId(state.scratchGui.projectState.loadingState),
    isShowingWithoutId: getIsShowingWithoutId(state.scratchGui.projectState.loadingState),
    projectChanged: state.scratchGui.projectChanged
});

const mapDispatchToProps = dispatch => ({
    onCreateProject: () => dispatch(createProject()),
    onUpdateProject: () => dispatch(manualUpdateProject())
});

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const {isShowingWithId, ...componentStateProps} = stateProps;

    return {
        ...componentStateProps,
        ...ownProps,
        onClickSave: () => {
            if (ownProps.canCreateNew && stateProps.isShowingWithoutId) {
                dispatchProps.onCreateProject();
            } else if (ownProps.canSave && isShowingWithId) {
                dispatchProps.onUpdateProject();
            }
        }
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(SaveStatus);
